import Joi from "joi-browser";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GiCheckMark } from "react-icons/gi";

import { xml2js } from "../../json/xml2js";
import {
  cloneForm,
  compareForms,
  deleteFormSubmission,
  getCareTeams,
  getClientData,
  getConfig,
  getFieldArray,
  getFieldLabel,
  getFieldOptions,
  getFieldValue,
  getFormsySubmissionsForClient,
  getSubmission,
  handleAddFieldTableRow,
  handleDeleteFieldTableRow,
  handleFieldTableChange,
  handleFormChange,
  saveForm,
  sendShareEmail,
  validateForm,
} from "../../scripts/formScriptsv2";
import {
  ArrayCheck,
  getFieldDate,
  getFieldName,
} from "../../scripts/helperScripts";
import {
  FormCheckbox,
  FormInput,
  FormRadioButton,
  FormSelect,
  FormTextArea,
} from "../common/ControlBundle";
import BackIcon from "../common/BackIcon";
import ClientFormHeader from "../common/ClientFormHeader";
import Comment from "../common/Comment";
import FormButtonBar from "../common/FormButtonBar";
import ShareModal from "../common/ShareModal";
import Signature from "../common/Signature";
import ExpandDiv from "./../common/ExpandDiv";

function SAFYFAIR() {
  const location = useLocation();
  const navigate = useNavigate();
  const initialProgram = location.state?.selectedProgram;

  //Get route and query string params
  const { clientid, formid, submissionid } = useParams();

  //Get logged in user info
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const [loadStatus, setLoadStatus] = useState({});
  //The complete Form Submission object with form data
  const [formsyDetails, setFormsyDetails] = useState({});
  const [formsyConfig, setFormsyConfig] = useState({});
  //The form data and previous forms
  const [data, setData] = useState({});
  const [allFormSubmissions, setAllFormSubmissions] = useState([]);
  //Touched fields
  const [touched, setTouched] = useState({});
  const [isSaveInProgress, setIsSaveInProgress] = useState(false);
  //Errors
  const [errors, setErrors] = useState({});
  //Client, Program and CareTeam Info
  const [clientData, setClientData] = useState({});
  const [careTeams, setCareTeams] = useState([]);

  //Signatures State Property
  const [signatures, setSignatures] = useState([]);
  //Show Signature Modal
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  //Comments state Property
  const [comments, setComments] = useState();
  //Show Comments Modal
  const [showComment, setShowComment] = useState(false);
  //Show Share Modal
  const [showShare, setShowShare] = useState(false);
  //Show Form Level (not field specific) Comments
  const [showFormComment, setShowFormComment] = useState(false);

  const [doCompare, setDoCompare] = useState(false);
  const [timeoutId, setTimeoutId] = useState();

  const pdfRef = useRef(true);
  const isMountedRef = useRef(true);

  //Joi validation schema
  const schema = {
    SelectedProgram: Joi.string().required().label("Selected Program"),
    Black: Joi.boolean(),
    White: Joi.boolean(),
    Hispanic: Joi.boolean(),
    OtherRace: Joi.boolean(),
    OtherRaceDetails: Joi.string().when("OtherRace", {
      is: true,
      then: Joi.required(),
    }),
    PlacementType: Joi.string().required().label("Type of Placement"),
    PlacementDuration: Joi.string().required().label("Placement Duration"),
    InterviewDate: Joi.string().required().label("Interview Date"),
    InterviewerName: Joi.string().required().label("Interviewer Name"),
    First: Joi.string().required().label("First runaway"),
    Voluntary: Joi.string().required().label("Voluntarily returned"),
    Escorted: Joi.when("Voluntary", {
      is: "No",
      then: Joi.string().required().label("Escorted home"),
    }),
    EscortedBy: Joi.when("Voluntary", {
      is: "No",
      then: Joi.when("Escorted", {
        is: "Yes",
        then: Joi.string().required().label("Escorted by whom"),
      }),
    }),
    WithinDay: Joi.string().required().label("Returned within 24 hours"),
    RunawayDuration: Joi.string().required().label("Runaway duration"),
    RepeatRunaway: Joi.string().required().label("Repeat runaway"),
    History: Joi.string().required().label("Runaway history"),
    Health: Joi.string().required(),
    RunawayPros: Joi.string().required().label("Runaway pros"),
    RunawayCons: Joi.string().required().label("Runaway cons"),
    RunawayProsReason: Joi.string().required().label("Runaway reason"),
    Important: Joi.string().required().label("Most important"),
    Triggers: Joi.string().required(),
    PlacementDescription: Joi.string()
      .required()
      .label("Placement description"),
    PlacementReason: Joi.string()
      .required()
      .label("Is placement the reason for runaway"),
    Family: Joi.string().required(),
    FamilyRelationship: Joi.string()
      .required()
      .label("Relationship with family"),
    FamilyReason: Joi.string()
      .required()
      .label("Is proximity to family the reason for runaway"),
    Friends: Joi.string().required(),
    FriendsRelationship: Joi.string()
      .required()
      .label("Relationship with friends"),
    FriendsReason: Joi.string()
      .required()
      .label("Is proximity to friends the reason for runaway"),
    Connections: Joi.string().required().label("Other connection"),
    ConnectionsRelationship: Joi.string()
      .required()
      .label("Relationship with other individuals"),
    ConnectionsReason: Joi.string()
      .required()
      .label("Is proximity to other individuals the reason for runaway"),
    SchoolDescription: Joi.string().required().label("School description"),
    SchoolPros: Joi.string().required().label("School pros"),
    SchoolCons: Joi.string().required().label("School cons"),
    SchoolReason: Joi.string().required().label("Is school the reason for"),
    RunawayProsReasonRating: Joi.when("RunawayProsReason", {
      is: "Yes",
      then: Joi.string().required().label("placeholder"),
    }),
    PlacementReasonRating: Joi.when("PlacementReason", {
      is: "Yes",
      then: Joi.string().required().label("placeholder"),
    }),
    FamilyReasonRating: Joi.when("FamilyReason", {
      is: "Yes",
      then: Joi.string().required().label("placeholder"),
    }),
    FriendsReasonRating: Joi.when("FriendsReason", {
      is: "Yes",
      then: Joi.string().required().label("placeholder"),
    }),
    ConnectionsReasonRating: Joi.when("ConnectionsReason", {
      is: "Yes",
      then: Joi.string().required().label("placeholder"),
    }),
    SchoolReasonRating: Joi.when("SchoolReason", {
      is: "Yes",
      then: Joi.string().required().label("placeholder"),
    }),
    Requests: Joi.string().required().label("Things to consider"),
    // InitialPlan: Joi.string().required().label("placeholder"),
    RunToNA: Joi.boolean(),
    RunToBfGf: Joi.boolean(),
    RunToSchool: Joi.boolean(),
    RunToFamily: Joi.boolean(),
    RunToCommunity: Joi.boolean(),
    RunToActivities: Joi.boolean(),
    RunToExcitement: Joi.boolean(),
    RunToFriends: Joi.boolean(),
    SelectedInterventions: Joi.array().items(Joi.string()),
  };

  const formDisabled = useMemo(() => {
    return formsyDetails.Active === "0" || formsyDetails.FinalSigned === "1";
  }, [formsyDetails.Active, formsyDetails.FinalSigned]);

  const formConfig = useMemo(() => {
    return formsyConfig.FormConfiguration?.[0].config[0] || null;
  }, [formsyConfig.FormConfiguration]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      pdfRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (initialProgram?.ccx_client_programid && data.SelectedProgram) {
      setData((d) => {
        const obj = { ...d };

        if (
          obj.SelectedProgram === undefined ||
          getFieldValue(obj.SelectedProgram)
        ) {
          return obj;
        }

        obj.SelectedProgram.value = initialProgram.ccx_client_programid;
        return obj;
      });

      setFormsyDetails((fd) => {
        const details = { ...fd };

        if (details.ClientProgramId === initialProgram.ccx_client_programid) {
          return details;
        }

        details.ClientProgramId = initialProgram.ccx_client_programid;
        details.ClientProgramName = getFieldName(
          initialProgram.ccx_programunit
        );
        return details;
      });
    }
  }, [initialProgram, data.SelectedProgram]);

  //Get Client Info
  useEffect(() => {
    if (!formid || !clientid) {
      return;
    }

    const loadClientInfo = async () => {
      const response = await Promise.all([
        getFormsySubmissionsForClient(formid, clientid),
        getCareTeams(clientid),
      ]);

      if (!isMountedRef.current || !response) {
        return;
      }

      setAllFormSubmissions(response[0]);
      setCareTeams(response[1]);
    };

    loadClientInfo();

    if (submissionid !== undefined) {
      const loadSubmission = async () => {
        const response = await getSubmission(submissionid);

        if (!isMountedRef.current || !response) {
          return;
        }

        setData(response.Data);
        setFormsyDetails(response.FormsyDetails);

        if (response.Comments) {
          setComments(response.Comments);
        }

        if (response.Signatures) {
          setSignatures(response.Signatures);
        }
      };

      loadSubmission();
    }
  }, [formid, clientid, submissionid]);

  useEffect(() => {
    if (
      !formid ||
      !clientid ||
      !safyInfo?.user ||
      loadStatus.configLoaded ||
      loadStatus.loadingConfig
    ) {
      return;
    }

    const loadConfig = async () => {
      setLoadStatus((ls) => {
        return { ...ls, loadingConfig: true };
      });
      const response = await getConfig(formid);

      if (!isMountedRef.current || !response) {
        return;
      }

      setFormsyConfig(response);
      const clientDataResponse = await getClientData(
        clientid,
        submissionid !== undefined,
        `${response.FormName}${
          response.VersionIntId > 1 ? `v${response.VersionIntId}` : ""
        }`
      );

      if (!isMountedRef.current || !clientDataResponse) {
        return;
      }

      setClientData(clientDataResponse);

      if (!submissionid) {
        //Set Formsy Details
        const newForm = {
          SubmissionId: "",
          FormId: response.FormId,
          FormVersionId: formid,
          ContactId: clientid,
          ContactName: clientDataResponse.client.fullName,
          ClientProgramId: "",
          ClientProgramName: "",
          TertiaryObjectId: "",
          TertiaryObjectName: "",
          FormResults: {
            results: {},
          },

          Comments: "",
          Signatures: "",
          CreatedOn: "",
          CreatedById: safyInfo.user.azureId,
          CreatedByName: safyInfo.user.displayName,
          ModifiedById: safyInfo.user.azureId,
          ModifiedByName: safyInfo.user.displayName,
          FinalSigned: "0",
          FinalSignedDate: "",
          Active: "1",
        };
        setFormsyDetails(newForm);
        setData(response.FormConfiguration[0].config[0]);
        setLoadStatus((ls) => {
          return {
            ...ls,
            loadingConfig: false,
            configLoaded: true,
          };
        });
      } else {
        setLoadStatus((ls) => {
          return { ...ls, loadingConfig: false, configLoaded: true };
        });
      }
    };

    loadConfig();
  }, [
    formid,
    clientid,
    safyInfo,
    submissionid,
    loadStatus.configLoaded,
    loadStatus.loadingConfig,
  ]);

  const helperConfiguration = useMemo(() => {
    const defaultConfig = {
      buttonBarConfig: {
        sign: {
          display: false,
          initialSignatureType: "full",
        },
        clone: {
          display: false,
        },
        delete: {
          display: false,
        },
        share: {
          display: false,
        },
        comment: {
          display: false,
        },
      },
      signatureType: "full",
      finalSignType: "Provider",
    };
    if (!formsyConfig.HelperConfiguration?.[0]) {
      return defaultConfig;
    }
    try {
      return JSON.parse(formsyConfig.HelperConfiguration[0]);
    } catch {
      return defaultConfig;
    }
  }, [formsyConfig.HelperConfiguration]);

  const getSelectedProgramName = (dataObj, cData) => {
    if (!dataObj.SelectedProgram || !cData.programs) {
      return "";
    }

    let name = getFieldName(dataObj.SelectedProgram);
    if (name) {
      return name;
    } else {
      const selectedProgram = cData.programs.filter(
        (p) => p.ccx_client_programid === getFieldValue(dataObj.SelectedProgram)
      )[0];

      if (selectedProgram) {
        name = getFieldName(selectedProgram.ccx_programunit);
        const programDates = ` (${getFieldDate(
          selectedProgram.ccx_admitdate
        )} - ${
          selectedProgram.ccx_dischargedate
            ? getFieldDate(selectedProgram.ccx_dischargedate)
            : "no date"
        })`;
        return name + programDates;
      } else {
        return "";
      }
    }
  };

  //Form validation
  const validate = () => {
    const results = validateForm(data, schema);
    setErrors(results);
    return results;
  };

  const handleChange = ({ currentTarget: input }) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const result = handleFormChange(input, data, schema, errors);
    setData(result.Data);
    setErrors(result.Errors);

    if (!submissionid) {
      return result.Data;
    }

    const touchedObj = { ...touched, [input.name]: true };
    const touchedFields = Object.keys(touchedObj).filter(
      (field) => touchedObj[field]
    );

    if (touchedFields.length >= 5) {
      if (isSaveInProgress) {
        const toId = setTimeout(() => {
          touchedFields.forEach((field) => (touchedObj[field] = false));
          handleSubmit(result.Data, null, null, null, true);
        }, 20000);

        setTimeoutId(toId);
      } else {
        clearTimeout(timeoutId);
        handleSubmit(result.Data, null, null, null, true);
        touchedFields.forEach((field) => (touchedObj[field] = false));
      }
    } else {
      const toId = setTimeout(() => {
        if (isSaveInProgress) {
          const toId2 = setTimeout(() => {
            touchedFields.forEach((field) => (touchedObj[field] = false));
            handleSubmit(result.Data, null, null, null, true);
          }, 20000);

          setTimeoutId(toId2);
        } else {
          touchedFields.forEach((field) => (touchedObj[field] = false));
          handleSubmit(result.Data, null, null, null, true);
        }
      }, 20000);

      setTimeoutId(toId);
    }

    setTouched(touchedObj);
    return result.Data;
  };

  const handleMultiselectChange = (fieldName, fieldValue) => {
    const e = {
      currentTarget: {
        name: fieldName,
        value: fieldValue,
        type: "multiselect",
      },
    };
    handleChange(e);
  };

  const handleRowChange = (e, index, fieldname) => {
    const rowObj = handleFieldTableChange(data, e, index, fieldname);
    setData((d) => {
      const obj = { ...d };
      obj[fieldname].value = rowObj;
      return obj;
    });
  };

  const handleDeleteRow = (index, fieldname) => {
    const rowObj = handleDeleteFieldTableRow(data, index, fieldname);
    setData((d) => {
      const obj = { ...d };
      obj[fieldname].value = rowObj;
      return obj;
    });
  };

  const handleAddRow = (fieldname, newRow, unshift = false) => {
    const rowObj = handleAddFieldTableRow(data, fieldname, newRow, unshift);
    setData((d) => {
      const obj = { ...d };
      obj[fieldname].value = rowObj;
      return obj;
    });
  };

  ////SAVE
  const handleSubmit = async (
    dataOverride,
    formsyDetailsOverride,
    commentsOverride,
    signaturesOverride,
    autoSave = false
  ) => {
    if (isSaveInProgress) {
      return;
    }

    const dataObj = dataOverride || data;
    const formsyDetailsObj = formsyDetailsOverride || formsyDetails;
    const commentsObj =
      commentsOverride === undefined ? undefined : commentsOverride || comments; // commentsOverride is usually null, but specifically undefined during Final Signing
    const signaturesObj = signaturesOverride || signatures;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTouched({});
    const errs = { ...errors };

    if (!dataObj.SelectedProgram?.value) {
      errs.SelectedProgram = '"Selected Program" is required';
      setErrors(errs);
      return;
    }

    delete errs.SelectedProgram;
    setErrors(errs);
    setIsSaveInProgress(true);

    try {
      const submissionResponse = await saveForm(
        dataObj,
        formsyDetailsObj,
        commentsObj,
        signaturesObj,
        navigate,
        location,
        autoSave
      );

      if (!isMountedRef.current || !submissionResponse?.Id) {
        return;
      }

      const newDetails = { ...formsyDetailsObj };
      newDetails.ModifiedOn = submissionResponse.LastModifiedOn;
      newDetails.ModifiedById = safyInfo.user.azureId;
      newDetails.ModifiedByName = safyInfo.user.displayName;

      if (newDetails.SubmissionId === "") {
        newDetails.SubmissionId = submissionResponse?.Id;
      }

      setFormsyDetails(newDetails);
    } finally {
      setIsSaveInProgress(false);
    }
  };

  ////CLONE
  const handleOnClone = (event) => {
    event.preventDefault();
    cloneForm(
      data,
      formsyDetails,
      comments,
      signatures,
      navigate,
      location,
      formsyConfig
    );
    setSignatures([]);
  };

  ////DELETE
  const handleDelete = (e) => {
    e.preventDefault();
    if (submissionid) {
      deleteFormSubmission(
        data,
        formsyDetails,
        comments,
        signatures,
        navigate,
        location
      );
    } else {
      alert("The form could not be deleted because it has not been saved");
    }
  };

  ////SHARE
  const toggleShareModal = () => {
    setShowShare(!showShare);
  };

  const handleShareSend = (recipientList, shareComments) => {
    sendShareEmail(
      recipientList,
      shareComments,
      location.pathname,
      data,
      formsyDetails,
      comments,
      signatures,
      formsyConfig.FormDescription
    );
  };

  ////COMMENTS FUNCTIONALITY
  const [commentToEdit, setCommentToEdit] = useState();

  const toggleCommentModal = (editComment) => {
    if (!showComment && editComment) setCommentToEdit(editComment);
    setShowComment(!showComment);
  };

  const handleComments = ({ action, fieldName, comment, acknowledge }) => {
    if (action === "ADD") {
      setShowComment(true);
    } else if (comment !== undefined) {
      if (action === "EDIT") {
        toggleCommentModal(comment);
      } else if (action === "DELETE") {
        handleDeleteComment(comment);
      } else if (action === "ACKNOWLEDGE" && acknowledge !== undefined) {
        handleAcknowledgeComment(comment, acknowledge);
      }
    } else if (action === "GET") {
      return parsedComments.filter(
        (comment) => comment.field._text === fieldName
      );
    }
  };

  const commentFields = () => {
    let commentOptions = [];
    commentOptions.push({ _id: "EntireForm", name: "Entire Form----" });
    for (const property in data) {
      if (
        data[property].type !== "section" &&
        data[property].type !== "label" &&
        data[property].type !== "User" &&
        data[property].type !== "hidden"
      ) {
        const option = {
          _id: property,
          name:
            data[property].label !== undefined && data[property].label !== ""
              ? data[property].label
              : property,
        };
        commentOptions.push(option);
      }
    }
    return commentOptions;
  };

  const parsedComments = useMemo(() => {
    if (!comments) {
      return [];
    }

    const commentObj = xml2js(`<comments type="array">${comments}</comments>`, {
      compact: true,
      spaces: 4,
    });

    return ArrayCheck(commentObj.comments.comment);
  }, [comments]);

  const onCommentSave = (comment, commentToEdit) => {
    let formsyComments;
    if (commentToEdit) {
      const commentXml = `<comment><createdby>${
        commentToEdit.createdby._text
      }</createdby><datetime>${commentToEdit.datetime._text}</datetime><field>${
        commentToEdit.field._text
      }</field><comment>${commentToEdit.comment._text}</comment>${
        commentToEdit.acknowledgedby
          ? `<acknowledgedby>${commentToEdit.acknowledgedby._text}</acknowledgedby><acknowledgedon>${commentToEdit.acknowledgedon._text}</acknowledgedon>`
          : ""
      }</comment>`;
      formsyComments =
        comments !== undefined
          ? comments.replace(commentXml, comment)
          : comment;
      setComments(formsyComments);
      setCommentToEdit(undefined);
    } else {
      formsyComments = comments !== undefined ? comments + comment : comment;
      setComments(formsyComments);
    }

    setShowComment(false);
    handleSubmit(null, null, formsyComments, null);
  };

  const handleDeleteComment = (comment) => {
    const commentXml = `<comment><createdby>${
      safyInfo.user.displayName
    }</createdby><datetime>${comment.datetime._text}</datetime><field>${
      comment.field._text
    }</field><comment>${comment.comment._text}</comment>${
      comment.acknowledgedby
        ? `<acknowledgedby>${comment.acknowledgedby._text}</acknowledgedby><acknowledgedon>${comment.acknowledgedon._text}</acknowledgedon>`
        : ""
    }</comment>`;

    let formsyComments = comments.replace(commentXml, "");
    if (formsyComments === "") formsyComments = undefined;
    setComments(formsyComments);
    handleSubmit(null, null, formsyComments, null);
  };

  const toggleCommentToEdit = (comment) => {
    setCommentToEdit(comment);
    setShowComment(true);
  };

  const handleAcknowledgeComment = (comment, acknowledge) => {
    if (acknowledge) {
      const oldCommentXML = `<comment><createdby>${comment.createdby._text}</createdby><datetime>${comment.datetime._text}</datetime><field>${comment.field._text}</field><comment>${comment.comment._text}</comment></comment>`;
      const newCommentXML = `<comment><createdby>${
        comment.createdby._text
      }</createdby><datetime>${comment.datetime._text}</datetime><field>${
        comment.field._text
      }</field><comment>${comment.comment._text}</comment><acknowledgedby>${
        safyInfo.user.displayName
      }</acknowledgedby><acknowledgedon>${moment().format(
        "L"
      )} ${moment().format("LT")}</acknowledgedon></comment>`;
      const formsyComments = comments.replace(oldCommentXML, newCommentXML);
      setComments(formsyComments);
      handleSubmit(null, null, formsyComments, null);
    } else {
      const oldCommentXML = `<comment><createdby>${comment.createdby._text}</createdby><datetime>${comment.datetime._text}</datetime><field>${comment.field._text}</field><comment>${comment.comment._text}</comment><acknowledgedby>${comment.acknowledgedby._text}</acknowledgedby><acknowledgedon>${comment.acknowledgedon._text}</acknowledgedon></comment>`;
      const newCommentXML = `<comment><createdby>${comment.createdby._text}</createdby><datetime>${comment.datetime._text}</datetime><field>${comment.field._text}</field><comment>${comment.comment._text}</comment></comment>`;
      const formsyComments = comments.replace(oldCommentXML, newCommentXML);
      setComments(formsyComments);
      handleSubmit(null, null, formsyComments, null);
    }
  };

  const handleCommentNavigation = (fieldName) => {
    const element = document.getElementById(fieldName);
    if (element.type === "checkbox")
      scrollTo(
        document.getElementById(fieldName).parentElement.parentElement
          .parentElement.offsetTop - 50,
        () => {
          document.getElementById(fieldName).focus();
        }
      );
    else
      scrollTo(document.getElementById(fieldName).offsetTop - 50, () => {
        document.getElementById(fieldName).focus();
      });
  };

  const renderComments = () => {
    return parsedComments
      .filter(
        (comment) =>
          comment.field._text === "EntireForm" ||
          comment.field._text === "Entire Form----"
      )
      .map((comment, index) => (
        <div className="mt-2" key={`form-comment-${index}`}>
          {showFormComment && (
            <div
              className={`${
                comment.acknowledgedby ? "bg-safy3-50" : "bg-warning"
              } p-2 m-2 rounded d-print-none`}
              title={
                comment.acknowledgedby
                  ? `Acknowledged by: ${comment.acknowledgedby._text} ${comment.acknowledgedon._text}`
                  : ""
              }
            >
              <span className="h6">
                {comment.createdby._text ===
                  JSON.parse(localStorage.getItem("safyInfo")).user
                    .displayName && (
                  <>
                    <i
                      title="Delete Comment"
                      className="far fa-trash-alt text-white me-2"
                      onClick={() => {
                        confirmAlert({
                          title: "Delete Comment",
                          message:
                            "Are you sure you want to delete this comment?",
                          buttons: [
                            {
                              label: "Yes",
                              onClick: () => {
                                handleDeleteComment(comment);
                              },
                            },
                            {
                              label: "No",
                              onClick: () => {
                                /* do nothing */
                              },
                            },
                          ],
                        });
                      }}
                    ></i>
                    {!comment.acknowledgedby && (
                      <i
                        title="Edit Comment"
                        className="fas fa-pen text-white me-2"
                        onClick={(e) => {
                          toggleCommentToEdit(comment);
                        }}
                      ></i>
                    )}
                  </>
                )}
                {comment.acknowledgedby && (
                  <i
                    className="far fa-check-square text-white me-2"
                    onClick={() => {
                      if (
                        comment.acknowledgedby._text ===
                        JSON.parse(localStorage.getItem("safyInfo")).user
                          .displayName
                      )
                        handleAcknowledgeComment(comment, false);
                    }}
                  ></i>
                )}
                {!comment.acknowledgedby && (
                  <i
                    className="far fa-square text-white me-2"
                    onClick={() => {
                      handleAcknowledgeComment(comment, true);
                    }}
                    title="Acknowledge Comment"
                  ></i>
                )}
                <br />
                {`${comment.createdby._text} - ${comment.datetime._text}`}
              </span>
              <br />
              Regarding:{" "}
              {comment.field._text !== "EntireForm" &&
              comment.field._text !== "Entire Form----" ? (
                <button
                  className="btn btn-link"
                  onClick={() => {
                    setTimeout(() => {
                      handleCommentNavigation(comment.field._text);
                    }, 100);
                  }}
                >
                  {comment.field._text}
                </button>
              ) : (
                <>{comment.field._text}</>
              )}
              <br />
              {comment.comment._text}
            </div>
          )}
        </div>
      ));
  };

  function scrollTo(offset, callback) {
    const fixedOffset = offset.toFixed();
    const onScroll = function () {
      if (window.pageYOffset.toFixed() === fixedOffset) {
        window.removeEventListener("scroll", onScroll);
        callback();
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll();
    window.scrollTo({
      top: offset,
      behavior: "smooth",
    });
  }

  //SIGNATURE FUNCTIONALITY
  const toggleSignatureModal = (e) => {
    e.preventDefault();
    if (!isSaveInProgress) setShowSignatureModal(true);
  };

  const saveSignature = async (signatureData) => {
    let sigArray = [];
    if (Array.isArray(signatureData)) {
      sigArray = signatureData;
    } else {
      sigArray.push(signatureData);
    }
    setSignatures(sigArray);

    const formsyDetailsObj = { ...formsyDetails };

    if (formsyDetailsObj.FinalSigned !== "1" && checkFinalSigned(sigArray)) {
      formsyDetailsObj.FinalSigned = "1";

      if (
        formsyDetailsObj.FinalSignedDate === "" ||
        formsyDetailsObj.FinalSignedDate === "1900-01-01T00:00:00"
      ) {
        formsyDetailsObj.FinalSignedDate = new Date();
      }

      setFormsyDetails(formsyDetailsObj);
      setComments(undefined);
    }

    handleSubmit(
      null,
      formsyDetailsObj,
      formsyDetailsObj.FinalSigned === "1" ? undefined : null,
      sigArray
    );
  };

  const checkFinalSigned = (sigArray) => {
    if (helperConfiguration.finalSignType === "Any") {
      return true;
    }

    const requiredSignatureTypes = helperConfiguration.finalSignType.split(",");
    const capturedSignatureTypes = sigArray.map((sig) => sig.signatureType);
    const missingSigTypes = requiredSignatureTypes.filter(
      (type) => !capturedSignatureTypes.includes(type)
    );
    return missingSigTypes.length === 0;
  };

  //COMPARE
  const compare = (field) => {
    if (doCompare)
      return compareForms(field, data, allFormSubmissions, formsyDetails);
  };

  const toggleCompare = () => {
    setDoCompare(!doCompare);
  };

  //CUSTOM
  const customValidate = (errs) => {
    // check that Runs To NA or at least 1 of the six are checked
    // ensure that at least one intervention for each runaway reason is checked
  };

  const ratingOptions = [
    { _id: "1", name: "1 (high priority)" },
    { _id: "2", name: "2" },
    { _id: "3", name: "3" },
    { _id: "4", name: "4" },
    { _id: "5", name: "5 (low priority)" },
  ];

  const selectedReasons = useMemo(() => {
    const reasons = [];

    if (data.RunToBfGf?.value === "true") {
      reasons.push("RunToBfGf");
    }
    if (data.RunToSchool?.value === "true") {
      reasons.push("RunToSchool");
    }
    if (data.RunToFamily?.value === "true") {
      reasons.push("RunToFamily");
    }
    if (data.RunToCommunity?.value === "true") {
      reasons.push("RunToCommunity");
    }
    if (data.RunToActivities?.value === "true") {
      reasons.push("RunToActivities");
    }
    if (data.RunToExcitement?.value === "true") {
      reasons.push("RunToExcitement");
    }
    if (data.RunToFriends?.value === "true") {
      reasons.push("RunToFriends");
    }

    return reasons;
  }, [
    data.RunToBfGf?.value,
    data.RunToSchool?.value,
    data.RunToFamily?.value,
    data.RunToCommunity?.value,
    data.RunToActivities?.value,
    data.RunToExcitement?.value,
    data.RunToFriends?.value,
  ]);

  const handleSelectedInterventionsChange = ({ currentTarget: input }) => {
    setData((d) => {
      const obj = { ...d };
      const selectedInterventions = getFieldArray(obj.SelectedInterventions);

      if (input.checked) {
        selectedInterventions.push(input.name);
      } else {
        const index = selectedInterventions.indexOf(input.name);
        selectedInterventions.splice(index, 1);
      }

      obj.SelectedInterventions.value = JSON.stringify(selectedInterventions);
      return obj;
    });
  };

  const interventions = useMemo(
    () => ({
      RunToBfGf: (
        <React.Fragment key="RunToBfGf">
          <div className="h4 border-bottom border-dark">
            Running to Boyfriend/Girlfriend
          </div>
          Running to spend time with a person the youth feels close to and has a
          romantic relationship with.
          <div className="ms-3">
            {selectedReasons.includes("RunToBfGf") ? (
              <FormCheckbox
                name="Love"
                label="Interventions For Love"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Love")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Love</div>
            )}
            The youth runs to access boyfriend/girlfriend for love.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Meet and include bf/gf in activities</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Invite bf/gf over for dinner and board game time
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Invite bf/gf to go on family outings
              </div>
              <div className="mb-3">
                <b>Allow more access to bf/gf</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow bf/gf to come over during specified times
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow more outings for the couple together with supervision, if
                necessary
              </div>
              <div className="mb-3">
                <b>Set ground rules for dating</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Set age appropriate curfews (e.g. if youth is 16 or older,
                curfew may be at 9pm)
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Discuss safe sex (including abstinence and birth control)
              </div>
              <div className="mb-3">
                <b>
                  Share information about healthy relationships and safe sex
                  with the youth
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Have the youth read information about high risk sexual behaviors
                and related health issues
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Have the youth watch a documentary on high risk sexual behaviors
                and related health issues
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Schedule an appointment with a doctor to talk about birth
                control and safe sex
              </div>
            </div>
            {selectedReasons.includes("RunToBfGf") ? (
              <FormCheckbox
                name="Belonging"
                label="Interventions For Belonging"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Belonging")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Belonging</div>
            )}
            The youth runs to be with boyfriend/girlfriend to feel a sense of
            being included and having someone care about them.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Help build other healthy relationships</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Arrange activities for roommates/housemates to build
                relationships with each other
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow more time for friends from school or other social groups
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to join clubs, teams or organizations that
                they have an interest in (within the school or outside of
                school)
              </div>
            </div>
            {selectedReasons.includes("RunToBfGf") ? (
              <FormCheckbox
                name="RunToBfGfFun"
                label="Interventions For Fun"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("RunToBfGfFun")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Fun</div>
            )}
            The youth runs to be with boyfriend/girlfriend to have fun and enjoy
            him/herself.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Organize outings and activities with placement</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Go to the beach
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Go cosmic bowling
              </div>
              <div className="mb-3">
                <b>
                  Get a peer or adult mentor that can organize and participate
                  in
                </b>
                different fun activities with the youth
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Enroll the youth in Big Brothers/Big Sisters
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Enroll the youth in other community based mentoring programs
              </div>
              <div className="mb-3">
                <b>Provide other fun activities for the youth to engage in</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Help the youth find a volunteer activity to participate in
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Help the youth find a paid job
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Help the youth engage in extracurricular activities at school »
                Discuss normalcy with caregiver
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Help to establish appropriate outings
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Establish appropriate curfew
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Help organize transportation so the youth can enjoy age-typical
                activities with his/her peers
              </div>
            </div>
            {selectedReasons.includes("RunToBfGf") ? (
              <FormCheckbox
                name="Access"
                label="Interventions For Access to Car/Money"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Access")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Access</div>
            )}
            The youth runs to boyfriend/girlfriend because he/she has a vehicle
            to get around and/or money to pay for things.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Help the youth acquire a paid job</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Assist the youth in creating a resume or filling out job
                applications
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Assist the youth in searching for job openings and obtaining
                transportation to/from potential work place
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Assist youth in learning interview skills to insure success at
                gaining employment
              </div>
              <div className="mb-3">
                <b>Help the youth arrange transportation</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Assist the youth in obtaining a bus pass
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Assist the youth in arranging rides from placement/caregivers
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
      RunToFamily: (
        <React.Fragment key="RunToFamily">
          <div className="h4 border-bottom border-dark">Running to Family</div>
          Running to any person the youth identifies as a family member that the
          youth would like to spend time with and/or interact with.
          <div className="ms-3">
            {selectedReasons.includes("RunToFamily") ? (
              <FormCheckbox
                name="Family"
                label="Interventions For Family"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Family")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Family</div>
            )}
            The youth runs to interact with and participate in preferred
            activities with individuals the youth identify as family.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>
                  Set up appropriate contact/interactions with family members
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Coordinate transportation for scheduled times to visit family
                members or family members to visit the youth at his/her
                placement
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Coordinate appropriate electronic contact with family members
                (Skype, Facebook, texting, sharing photos and videos, etc.)
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Surprise the youth by picking them up for unscheduled visits
                with family members
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Coordinate for family members to accompany or meet the youth at
                scheduled outings
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Coordinate for family members to participate in school and
                community activities with the youth (band, sports, school open
                house, church events, etc.)
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Coordinate family phone calls at regular scheduled times
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Set up conference calls when family members have events far away
                or difficult for the youth to attend (weddings, births, birthday
                celebrations, etc.)
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Arrange for the youth to attend church or religious services
                with family members
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Arrange for the youth to mail artwork, letters, photos, “All
                About Me” portfolios, etc., to family members and to receive
                mailed materials from family members
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Arrange for the youth and family members to watch a favorite TV
                show together and call each other during or after the show
              </div>
              <div className="mb-3">
                <b>
                  Interview the youth to develop a prioritized list of
                  individuals the youth identifies as a family member
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Ask the youth which family members he/she would like to have
                scheduled visits with
              </div>
              <div className="mb-3">
                <b>Explore moving the youth closer to family</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Move the youth to same county as biological family
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Move the youth from a group home placement to relative caregiver
              </div>
            </div>
            {selectedReasons.includes("RunToFamily") ? (
              <FormCheckbox
                name="Belonging"
                label="Interventions For Belonging"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Belonging")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Belonging</div>
            )}
            The youth runs to family members for a sense of belonging or
            familiarity.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>
                  Find other family members, neighbors, or church members the
                  youth could be placed with
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                The youth has an aunt who lives nearby and is willing to be a
                relative caregiver
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                The youth has a family friend who lives nearby and is willing to
                be a nonrelative caregiver
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Explore adoption services if applicable for the youth
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
      RunToActivities: (
        <React.Fragment>
          <div className="h4 border-bottom border-dark">
            Running to Preferred Activities
          </div>
          Running to an activity the youth finds enjoyable and likes to do.
          <div className="ms-3">
            {selectedReasons.includes("RunToActivities") ? (
              <FormCheckbox
                name="Normalcy"
                label="Interventions For Normalcy"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Normalcy")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Normalcy</div>
            )}
            The youth runs due to lack of age appropriate activities, and age
            appropriate rules as well as running from the embarrassment
            associated with living at a group home or foster placement.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Put age appropriate rules in place</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Friends of the youth wouldn't have to check the youth in and out
                of the group home, or sign in and out of the home
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to have a driver's license
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Change rules regarding cell-phone use, access to fridge, asking
                to go to the restroom and provide the youth with his/her own key
                to his/her room
                <br />
              </div>
              <div className="mb-3">
                <b>Stability in staff</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Place the youth in a group home with a home-mom and/or home-dad
                that stay at the group home full-time
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Put incentives in place for staff who stay longer
                <br />
              </div>
              <div className="mb-3">
                <b>Organize placements by age</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Have kids of like ages in the home/group placement
                <br />
              </div>
              <div className="mb-3">
                <b>No labels with group home name</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Keep group home logos/labels out of sight when the youth are on
                outings in the community, such as on the group home vans
              </div>
            </div>
            {selectedReasons.includes("RunToActivities") ? (
              <FormCheckbox
                name="Drugs"
                label="Interventions For Drugs, Sex, etc."
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Drugs")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Drugs, Sex, etc.</div>
            )}
            The youth runs to access activities such as drugs or sex, the youth
            may not be aware or not care of the dangers associated with them.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Provide information</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Have an aged out youth with a history of running from his/her
                placement mentor and share his/her experiences of what dangers
                can occur while on the run
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Give information of healthy relationships and safe sex
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Teach the youth about the dangers of drug/alcohol use, may
                include role-playing situations the youth has encountered
                <br />
              </div>
              <div className="mb-3">
                <b>
                  Survey the youth to see what other activities they may enjoy
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                See if the youth would enjoy a thrill-seeking activity such as
                paintballing, skateboarding, etc.
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                See if youth would enjoy other extracurricular activities
              </div>
            </div>
            {selectedReasons.includes("RunToActivities") ? (
              <FormCheckbox
                name="Stimulation"
                label="Interventions For Stimulation/Choices"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Stimulation")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Stimulation/Choices</div>
            )}
            The youth runs due to lack of engagement in activities and minimal
            opportunities to choose something they prefer.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Schedule planned activities</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Going to the beach, park, mall
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Events with siblings, even if they do not live in same placement
                <br />
              </div>
              <div className="mb-3">
                <b>Give preference and choice making to the youth</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Let the youth have a few different options for food, could even
                have the youth help make the dinner of his/her choosing
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Let the youth pick an activity that he wants to do (watch a
                movie, go to the mall with a friend, have a sibling/friend over)
              </div>
            </div>
            {selectedReasons.includes("RunToActivities") ? (
              <FormCheckbox
                name="Involvement"
                label="Interventions For Involvement in Extracurricular Activities"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Involvement")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">
                Interventions For Involvement in Extracurricular Activities
              </div>
            )}
            The youth runs to attend practices/meetings/events for
            extracurricular activities he/she is/would like to be involved in.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Facilitate better communication</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Facilitate better collaboration between group home and schools
                to see what is available for the youth
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                The school and group home can work with transportation options
                for the youth
                <br />
              </div>
              <div className="mb-3">
                <b>
                  Provide opportunity for the youth to become involved in
                  extracurricular activities.
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Group home should provide better/reliable transportation for the
                youth if he/she wants to go to a school dance, be a member of a
                club, get tutoring, or be on a team (e.g. baseball, volleyball,
                etc.)
              </div>
            </div>
            {selectedReasons.includes("RunToActivities") ? (
              <FormCheckbox
                name="Independence"
                label="Interventions For Independence"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Independence")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Independence</div>
            )}
            The youth runs to escape from the rules of his/her placement and
            show his/her independence and confidence.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>
                  Allow the youth to help identify rules for themselves in
                  his/her placement
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to choose a reward to earn
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to have input in curfew
                <br />
              </div>
              <div className="mb-3">
                <b>Allow the youth to have access to his/her house</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Give the youth a key to his/her room
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Give the youth a key to the house
                <br />
              </div>
              <div className="mb-3">
                <b>Consider the youth's preference for routine activities</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to pick what is for dinner that night
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to choose what to watch on TV
                <br />
              </div>
              <div className="mb-3">
                <b>
                  Promote activities that allow the youth to feel more
                  independent from the group home
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to get involved in extracurricular
                activities
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to engage in school clubs, music, or sports
                <br />
              </div>
              <div className="mb-3">
                <b>Provide transportation for the youth</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Make arrangements to pick the youth up after school activities
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Explore possibilities for carpooling with a school coach
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Look into providing the youth with a bus pass
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
      RunToFriends: (
        <React.Fragment>
          <div className="h4 border-bottom border-dark">Running to Friends</div>
          Running to a person who the youth has shared interests with, exclusive
          of sexual or family relations.
          <div className="ms-3">
            {selectedReasons.includes("RunToFriends") ? (
              <FormCheckbox
                name="Belonging"
                label="Interventions For Belonging"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Belonging")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Belonging</div>
            )}
            The youth runs to friends to gain a sense that someone cares about
            them and understands them.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Allow visits</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow friends over for a sleep over
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow friends to go with the youth on scheduled outing
                <br />
              </div>
              <div className="mb-3">
                <b>Facilitate friendships in the home</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Do team building activities
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage sharing and bonding by helping the youth identify
                mutual interests and activities with others in his/her placement
                <br />
              </div>
              <div className="mb-3">
                <b>Allow more access to friends</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Provide transportation for the youth to see friends
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to invite friends over
                <br />
              </div>
              <div className="mb-3">
                <b>Support group</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to attend a foster care support group
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Create a support group within a group placement
                <br />
              </div>
              <div className="mb-3">
                <b>Help build other healthy relationships</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Involve the youth in extracurricular activities
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Get the youth a mentor or a supportive friend within the group
                placement
              </div>
            </div>
            {selectedReasons.includes("RunToFriends") ? (
              <FormCheckbox
                name="RunToFriendsFun"
                label="Interventions For Fun"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("RunToFriendsFun")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Fun</div>
            )}
            The youth runs to access friends so they can engage in activities
            they enjoy.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Set up enjoyable outings/activities with placement</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Go to a movie that the youth chooses
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to go to the mall without supervision
                <br />
              </div>
              <div className="mb-3">
                <b>Provide other structured activities</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to get a job
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to volunteer somewhere where he/she enjoys
                <br />
              </div>
              <div className="mb-3">
                <b>Later curfew that coincides with age</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Promote normalcy by giving older youth later curfews
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow later curfews if the youth asks in advance
                <br />
              </div>
              <div className="mb-3">
                <b>Discuss normalcy with caregiver</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Discuss with the caregiver what is an appropriate curfew
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Caregiver can encourage friendships and extracurriculars
              </div>
            </div>
            {selectedReasons.includes("RunToFriends") ? (
              <FormCheckbox
                name="RunToFriendsOther"
                label="Other"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("RunToFriendsOther")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Other</div>
            )}
            The youth runs for other circumstances or for multiple circumstances
            listed above.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Engage in extracurricular activities at school</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to play sports
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to join clubs
                <br />
              </div>
              <div className="mb-3">
                <b>Allow more phone/ computer time</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to use his/her phone or computer (age
                appropriately) while at his/her placement
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage Skype conversations with his/her friends
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
      RunToSchool: (
        <React.Fragment>
          <div className="h4 border-bottom border-dark">Running to School</div>
          Running to access the school they previously attended or another
          school environment.
          <div className="ms-3">
            {selectedReasons.includes("RunToSchool") ? (
              <FormCheckbox
                name="Teachers"
                label="Interventions For Previous Teachers"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Teachers")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Previous Teachers</div>
            )}
            The youth runs to preferred teachers at a different school.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>See if old teachers can provide tutoring</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Provide transportation to old school for tutoring
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Have the old teacher come to the placement or common place for
                tutoring
                <br />
              </div>
              <div className="mb-3">
                <b>Arrange a mentor for the youth</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Enroll in Big Brothers/Big Sisters
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Find a teacher within the school to help the youth in his/her
                current school setting
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Find someone older in same placement that can help with school
                work
                <br />
              </div>
              <div className="mb-3">
                <b>Figure out why the youth likes the old teacher</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                See if he/she gave the youth anything (food, supplies, etc.)
                that the youth liked, and set up times the youth can earn this
                preferred item
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Examine his/her teaching style to see if it can be done in the
                home setting or the youth's new school
                <br />
              </div>
              <div className="mb-3">
                <b>Allow contact with the old teacher</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Set up Skype or phone conversations where the youth can talk to
                his/her old teacher
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to visit the teacher after school (provide
                transportation to old school)
              </div>
            </div>
            {selectedReasons.includes("RunToSchool") ? (
              <FormCheckbox
                name="Peers"
                label="Interventions For Previous Peers"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Peers")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Previous Peers</div>
            )}
            The youth runs to anyone that is close to the youth's own age that
            he/she have had previous contact with at school.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Allow more phone or computer time</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to text and call friends
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to contact friends through Facebook or Skype
                <br />
              </div>
              <div className="mb-3">
                <b>Allow visits from old friends at current placement</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Arrange sleep overs with old friends
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Invite old friends on scheduled activities
                <br />
              </div>
              <div className="mb-3">
                <b>Help build other healthy relationships</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Involve the youth in extracurricular activities
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Strengthen relationships between staff and the youth
              </div>
            </div>
            {selectedReasons.includes("RunToSchool") ? (
              <FormCheckbox
                name="Stability"
                label="Interventions For Academic Stability"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Stability")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Academic Stability</div>
            )}
            The youth runs to previous school because the youth's educational
            outcome was better there, or to access previous classes at that
            school.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Tutoring</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Provide the youth with tutoring from a preferred person
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Set up times for the youth to get tutoring from teachers whose
                class he/she is struggling in
                <br />
              </div>
              <div className="mb-3">
                <b>
                  Give child welfare liaison awareness of the youths' needs at
                  school
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Let child welfare liaison know the situation with the youth and
                ask him/her to advocate for the youth
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Ask for the child welfare liaison to check in on the youth
                <br />
              </div>
              <div className="mb-3">
                <b>Individualized help in the current placement</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to choose someone that he/she would like to
                receive help from
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Have a staff member provide daily school work help for the youth
                <br />
              </div>
              <div className="mb-3">
                <b>Monitor the youth's progress at school</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Set up weekly parent-teacher conferences
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Ask for daily reports from teacher
              </div>
            </div>
            {selectedReasons.includes("RunToSchool") ? (
              <FormCheckbox
                name="Extracurriculars"
                label="Interventions For Extracurriculars"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Extracurriculars")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Extracurriculars</div>
            )}
            The youth runs to a school to be involved with after school
            activities such as sports or clubs.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>
                  Encourage the youth to participate in school activities that
                  he/she likes
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to participate in his/her preferred sport at
                the new school
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to join clubs around his/her interests
                <br />
              </div>
              <div className="mb-3">
                <b>Reward the youth if he/she does well in school</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                If you go to school then you can try out for volleyball
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                If you go to school you can stay after for drama club
                <br />
              </div>
              <div className="mb-3">
                <b>Make the curfew less strict</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                If the youth states that he/she is going to an extracurricular
                activity allow him/her to be home later and provide
                transportation
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow later curfews when the youth wants to attend school events
                like football games or dances
              </div>
            </div>
            {selectedReasons.includes("RunToSchool") ? (
              <FormCheckbox
                name="RunToSchoolOther"
                label="Other"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("RunToSchoolOther")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Other</div>
            )}
            The youth runs for other circumstances or for multiple circumstances
            listed above.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Provide transportation to old school</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Group home provides transportation to old school
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Look into school resources to provide transportation to old
                school
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
      RunToCommunity: (
        <React.Fragment>
          <div className="h4 border-bottom border-dark">
            Running to Community Supports
          </div>
          Running to access additional supports within the community that the
          youth has a relationship with that may be able to provide the youth
          with preferred items/activities
          <div className="ms-3">
            {selectedReasons.includes("RunToCommunity") ? (
              <FormCheckbox
                name="Relationships"
                label="Interventions For Relationships"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Relationships")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Relationships</div>
            )}
            The youth runs to access relationships within the community.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>
                  Involve the youth in church (either previous or new) for a
                  sense of community
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Involve the youth in church youth groups
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Provide transportation to the youth's old church/new church
                activities
                <br />
              </div>
              <div className="mb-3">
                <b>
                  Allow the youth to volunteer with a charity of his/her choice
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Get the youth involved in something meaningful to him/her
              </div>
            </div>
            {selectedReasons.includes("RunToCommunity") ? (
              <FormCheckbox
                name="Transportation"
                label="Interventions For Transportation"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Transportation")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Transportation</div>
            )}
            The youth runs to access transportation from community
            members/groups.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>
                  Find neighbors, church members, or other community members who
                  may want to provide transportation
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Identify a church member who can help with transportation
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Identify neighbors/ community members the youth is close to who
                can help the youth get around the community
              </div>
            </div>
            {selectedReasons.includes("RunToCommunity") ? (
              <FormCheckbox
                name="Other"
                label="Other"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Other")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Other</div>
            )}
            The youth runs to access other preferred items or activities in the
            community.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Help the youth find employment or a volunteer activity</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to get a job in the community
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
      RunToExcitement: (
        <React.Fragment>
          <div className="h4 border-bottom border-secondary">
            Running to Excitement
          </div>
          Running to experience the feeling of excitement; an ‘adrenaline rush'
          or ‘high' that may occur when the youth is on the run
          <div className="ms-3">
            {selectedReasons.includes("RunToExcitement") ? (
              <FormCheckbox
                name="Adrenaline"
                label="Interventions For an Adrenaline Rush"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Adrenaline")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For an Adrenaline Rush</div>
            )}
            The youth runs so he/she can feel a rush of adrenaline/excitement.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>Provide the youth with exciting activities to engage in</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Help youth join a community sports team (soccer, baseball, etc.)
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Help youth join a school sports team (football, basketball,
                etc.)
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Bring youth to an exciting activity (paintball range, skate
                park, etc.)
                <br />
              </div>
              <div className="mb-3">
                <b>
                  Organize outings and activities with placement that are
                  exciting to the youth (have the youth choose)
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Go to the beach to skim/boogie board
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Go to an amusement park to ride roller coasters
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Go biking
                <br />
              </div>
              <div className="mb-3">
                <b>
                  Get a peer or adult mentor that can organize and participate
                  in different exciting activities
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Enroll the youth in Big Brothers/Big Sisters
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Enroll the youth in other community based mentoring programs
              </div>
            </div>
            {selectedReasons.includes("RunToExcitement") ? (
              <FormCheckbox
                name="Fun"
                label="Interventions For Fun"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Fun")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">Interventions For Fun</div>
            )}
            The youth runs so he/she can have fun and enjoy him/herself.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>
                  Organize outings and activities with placement that are
                  exciting to the youth (have them choose)
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Go to the beach to skim/boogie board
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Go to an amusement park to ride roller coasters
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Go biking
                <br />
              </div>
              <div className="mb-3">
                <b>
                  Get a peer or adult mentor that can organize and participate
                  in different fun activities
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Enroll the youth in Big Brothers/Big Sisters
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Enroll the youth in other community based mentoring programs
                <br />
              </div>
              <div className="mb-3">
                <b>Provide the youth with other activities to engage in</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Help the youth find a fun volunteer activity to participate in
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Help the youth find a fun paid job
                <br />
              </div>
              <div className="mb-3">
                <b>Educate the youth on the dangers of running</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Have youth who have aged out of the child welfare system share
                experiences about some of the negative or harmful repercussions
                of engaging in high excitement risky behaviors
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Organize youth rap/chat sessions for the youth to talk to other
                peers about his/her negative experiences while on the run
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to participate in information sessions about
                high risk behaviors from another teen's perspective
                <br />
              </div>
              <div className="mb-3">
                <b>
                  Share information about healthy relationships and safe sex
                  with the youth
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Have the youth read information about high risk sexual behavior
                behaviors and related health issues
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Have the youth watch a documentary on high risk sexual behaviors
                and related health issues
              </div>
            </div>
            {selectedReasons.includes("RunToExcitement") ? (
              <FormCheckbox
                name="Freedom"
                label="Interventions For Absence of Rules/Freedom"
                checked={JSON.parse(
                  data.SelectedInterventions?.value || "[]"
                ).includes("Freedom")}
                onChange={handleSelectedInterventionsChange}
                commentsHandler={handleComments}
                disabled={formDisabled}
                className="h5"
                labelClassName="h5"
              />
            ) : (
              <div className="h5">
                Interventions For Absence of Rules/Freedom
              </div>
            )}
            The youth runs to experience freedom and escape from the rules of
            his/her placement.
            <div className="ms-2 mt-2 mb-3">
              <div className="mb-3">
                <b>
                  Allow the youth to help identify rules for him/herself in
                  his/her placement
                </b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to choose a reward to earn
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to have input in curfew
                <br />
              </div>
              <div className="mb-3">
                <b>Allow the youth to have access to his/her house</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Give the youth a key to his/her room
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Give the youth a key to the house
                <br />
              </div>
              <div className="mb-3">
                <b>Consider the youth's preference for routine activities</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to pick what is for dinner that night
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Allow the youth to choose what to watch on TV
                <br />
              </div>
              <div className="mb-3">
                <b>Promote activities to allow the youth to feel “normal”</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to get involved in extracurricular
                activities
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Encourage the youth to engage in school clubs, music or sports
                <br />
              </div>
              <div className="mb-3">
                <b>Provide transportation for the youth</b>
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Make arrangements to pick the youth up after school activities
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Explore possibilities for carpooling with a school coach
                <br />
                <i className="far fa-lightbulb fa-sm ms-3 me-2" />
                Look into providing the youth with a bus pass
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    }),
    [selectedReasons, data.SelectedInterventions?.value]
  );

  const otherInterventions = useMemo(() => {
    const allReasons = Object.keys(interventions);
    const other = allReasons.filter((r) => !selectedReasons.includes(r));
    return other;
  }, [selectedReasons, interventions]);

  ////UI
  return (
    <>
      <div className="mb-2">
        <BackIcon />
      </div>
      <div className={!submissionid ? "watermarked" : ""} ref={pdfRef}>
        <ClientFormHeader
          formTitle={formsyConfig.FormDescription}
          clientData={clientData.client}
          formsyDetails={formsyDetails}
        />
        <FormButtonBar
          config={helperConfiguration.buttonBarConfig}
          onSave={handleSubmit}
          onClone={handleOnClone}
          onDelete={handleDelete}
          onSignClicked={toggleSignatureModal}
          onComment={toggleCommentModal}
          onCompare={toggleCompare}
          onShare={toggleShareModal}
          signed={signatures.length > 0}
          finalSigned={formsyDetails.FinalSigned === "1"}
          validate={validate}
          pdfRef={pdfRef}
          filename={`${formsyConfig.FormDescription}`}
          newestVersion={
            formsyConfig.VersionIntId === formsyConfig.LatestVersionIntId
          }
          customValidate={customValidate}
        />
        <div className="py-2 border-bottom border-dark">
          <b>Selected Client Program:</b>{" "}
          {getSelectedProgramName(data, clientData)}
        </div>
        {renderComments()}
        {parsedComments.filter(
          (comment) =>
            comment.field._text === "EntireForm" ||
            comment.field._text === "Entire Form----"
        ).length > 0 && (
          <i
            className="fas fa-comment-alt text-warning float-end mb-2 ms-2"
            onClick={() => setShowFormComment(!showFormComment)}
          ></i>
        )}
        <div className="mt-4">
          {data.SelectedProgram?.value !== undefined && formConfig !== null && (
            <>
              <ExpandDiv
                id="knowledgeSheet"
                className="mt-2"
                title="Knowledge Sheet for Preparing for the FAIR Interview with the Youth"
                expandStatus={true}
              >
                <div className="container">
                  <div className="row">
                    <div className="col-auto">Race:</div>
                    <div className="col-auto">
                      <FormCheckbox
                        name="Black"
                        label={getFieldLabel(formConfig.Black)}
                        checked={getFieldValue(data.Black) === "true"}
                        onChange={handleChange}
                        commentsHandler={handleComments}
                        disabled={formDisabled}
                      />
                    </div>
                    <div className="col-auto">
                      <FormCheckbox
                        name="White"
                        label={getFieldLabel(formConfig.White)}
                        checked={getFieldValue(data.White) === "true"}
                        onChange={handleChange}
                        commentsHandler={handleComments}
                        disabled={formDisabled}
                      />
                    </div>
                    <div className="col-auto">
                      <FormCheckbox
                        name="Hispanic"
                        label={getFieldLabel(formConfig.Hispanic)}
                        checked={getFieldValue(data.Hispanic) === "true"}
                        onChange={handleChange}
                        commentsHandler={handleComments}
                        disabled={formDisabled}
                      />
                    </div>
                    <div className="col-auto">
                      <FormCheckbox
                        name="OtherRace"
                        label={getFieldLabel(formConfig.OtherRace)}
                        checked={getFieldValue(data.OtherRace) === "true"}
                        onChange={handleChange}
                        commentsHandler={handleComments}
                        disabled={formDisabled}
                      />
                    </div>
                  </div>
                  {getFieldValue(data.OtherRace) === "true" ? (
                    <FormInput
                      name="OtherRaceDetails"
                      label={getFieldLabel(formConfig.OtherRaceDetails)}
                      error={errors.OtherRaceDetails}
                      value={data.OtherRaceDetails.value}
                      onChange={handleChange}
                      identical={compare("OtherRaceDetails")}
                      commentsHandler={handleComments}
                      disabled={formDisabled}
                      divClassName="mt-2"
                    />
                  ) : null}
                  <div className="row mt-2">
                    <div className="col-6">
                      <FormInput
                        name="PlacementType"
                        label={getFieldLabel(formConfig.PlacementType)}
                        error={errors.PlacementType}
                        value={data.PlacementType.value}
                        onChange={handleChange}
                        identical={compare("PlacementType")}
                        commentsHandler={handleComments}
                        disabled={formDisabled}
                      />
                    </div>
                    <div className="col-6">
                      <FormInput
                        name="PlacementDuration"
                        label={getFieldLabel(formConfig.PlacementDuration)}
                        error={errors.PlacementDuration}
                        value={data.PlacementDuration.value}
                        onChange={handleChange}
                        identical={compare("PlacementDuration")}
                        commentsHandler={handleComments}
                        disabled={formDisabled}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto">
                      <FormInput
                        name="InterviewDate"
                        label={getFieldLabel(formConfig.InterviewDate)}
                        error={errors.InterviewDate}
                        value={data.InterviewDate.value}
                        onChange={handleChange}
                        identical={compare("InterviewDate")}
                        commentsHandler={handleComments}
                        disabled={formDisabled}
                        type="date"
                      />
                    </div>
                    <div className="col">
                      <FormInput
                        name="InterviewerName"
                        label={getFieldLabel(formConfig.InterviewerName)}
                        error={errors.InterviewerName}
                        value={data.InterviewerName.value}
                        onChange={handleChange}
                        identical={compare("InterviewerName")}
                        commentsHandler={handleComments}
                        disabled={formDisabled}
                      />
                    </div>
                  </div>
                  <h5 className="mt-3">Runaway Episode Information</h5>
                  <FormRadioButton
                    name="First"
                    label={getFieldLabel(formConfig.First)}
                    error={errors.First}
                    value={data.First.value}
                    options={getFieldOptions(data.First)}
                    onChange={handleChange}
                    identical={compare("First")}
                    commentsHandler={handleComments}
                    disabled={formDisabled}
                  />
                  <FormRadioButton
                    name="Voluntary"
                    label={getFieldLabel(formConfig.Voluntary)}
                    error={errors.Voluntary}
                    value={data.Voluntary.value}
                    options={getFieldOptions(data.Voluntary)}
                    onChange={handleChange}
                    identical={compare("Voluntary")}
                    commentsHandler={handleComments}
                    disabled={formDisabled}
                  />
                  {getFieldValue(data.Voluntary) === "No" ? (
                    <>
                      <FormRadioButton
                        name="Escorted"
                        label={getFieldLabel(formConfig.Escorted)}
                        error={errors.Escorted}
                        value={data.Escorted.value}
                        options={getFieldOptions(data.Escorted)}
                        onChange={handleChange}
                        identical={compare("Escorted")}
                        commentsHandler={handleComments}
                        disabled={formDisabled}
                      />
                      {getFieldValue(data.Escorted) === "Yes" ? (
                        <FormInput
                          name="EscortedBy"
                          label={getFieldLabel(formConfig.EscortedBy)}
                          error={errors.EscortedBy}
                          value={data.EscortedBy.value}
                          onChange={handleChange}
                          identical={compare("EscortedBy")}
                          commentsHandler={handleComments}
                          disabled={formDisabled}
                          divClassName="mt-2"
                        />
                      ) : null}
                    </>
                  ) : null}
                  <FormRadioButton
                    name="WithinDay"
                    label={getFieldLabel(formConfig.WithinDay)}
                    error={errors.WithinDay}
                    value={data.WithinDay.value}
                    options={getFieldOptions(data.WithinDay)}
                    onChange={handleChange}
                    identical={compare("WithinDay")}
                    commentsHandler={handleComments}
                    disabled={formDisabled}
                    divClassName="mt-2"
                  />
                  <FormInput
                    name="RunawayDuration"
                    label={getFieldLabel(formConfig.RunawayDuration)}
                    error={errors.RunawayDuration}
                    value={data.RunawayDuration.value}
                    onChange={handleChange}
                    identical={compare("RunawayDuration")}
                    commentsHandler={handleComments}
                    disabled={formDisabled}
                    divClassName="mt-2"
                  />
                  <h5>Youth's Runaway History</h5>
                  <FormRadioButton
                    name="RepeatRunaway"
                    label={getFieldLabel(formConfig.RepeatRunaway)}
                    error={errors.RepeatRunaway}
                    value={data.RepeatRunaway.value}
                    options={getFieldOptions(data.RepeatRunaway)}
                    onChange={handleChange}
                    identical={compare("RepeatRunaway")}
                    commentsHandler={handleComments}
                    disabled={formDisabled}
                  />
                  <FormTextArea
                    name="History"
                    label={getFieldLabel(formConfig.History)}
                    error={errors.History}
                    value={data.History.value}
                    onChange={handleChange}
                    identical={compare("History")}
                    commentsHandler={handleComments}
                    disabled={formDisabled}
                    divClassName="mt-2"
                  />
                </div>
              </ExpandDiv>
              <ExpandDiv
                id="interview"
                className="mt-2"
                title="Functional Assessment Interview for Runaways (FAIR)"
              >
                <h5>Instructions for Interviewer</h5>
                Ask each question, tailoring each as needed. Use probe questions
                to solicit specific information on the given question. Before
                beginning the interview, the interviewer should emphasize how
                the youth will likely benefit from participating in the
                interview. Throughout the interview, remember to show
                empathy/concern about what youth is saying by asking follow up
                questions as needed.
                <h5 className="mt-3">Interview Introduction</h5>
                <div className="ms-3">
                  <p style={{ textIndent: "-5px" }}>
                    <i>
                      "You may recall when you were spoken to after you returned
                      from your run, that I wanted a chance to talk with you as
                      well. If it's okay with you, I would like to understand
                      what might be done to improve your situation to better
                      meet your needs and interests. The more I can understand{" "}
                      <b>what's good and not so good</b> about your placement,
                      school, friends, and others who you're close to, the
                      better I'll be able to help you have the kind of situation
                      you might like better. At the end of the interview you and
                      I will review this information and begin developing a plan
                      that identifies things that both of us can do over the
                      next few days and weeks to see about improving your
                      situation. I cannot guarantee that you will get everything
                      that you want, but I promise to do my best to try to get
                      as much accomplished as possible for you and expect this
                      plan to help make things better for you. Are you game for
                      us to talk to see what we can do together?"
                    </i>
                  </p>
                </div>
                <h4 className="mt-3">HEALTH</h4>
                <FormTextArea
                  name="Health"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.Health)}</b>
                      <br />
                      {formConfig.Health.subLabel}
                    </>
                  }
                  error={errors.Health}
                  value={data.Health.value}
                  onChange={handleChange}
                  identical={compare("Health")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="2"
                />
                <h4 className="mt-3">RUN EXPERIENCE</h4>
                <FormTextArea
                  name="RunawayPros"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.RunawayPros)}</b>
                      <br />
                      {formConfig.RunawayPros.subLabel}
                      <br />
                      {formConfig.RunawayPros.subLabel2}
                    </>
                  }
                  error={errors.RunawayPros}
                  value={data.RunawayPros.value}
                  onChange={handleChange}
                  identical={compare("RunawayPros")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="3"
                />
                <FormTextArea
                  name="RunawayCons"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.RunawayCons)}</b>
                      <br />
                      {formConfig.RunawayCons.subLabel}
                      <br />
                      {formConfig.RunawayCons.subLabel2}
                    </>
                  }
                  error={errors.RunawayCons}
                  value={data.RunawayCons.value}
                  onChange={handleChange}
                  identical={compare("RunawayCons")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="3"
                />
                <FormRadioButton
                  name="RunawayProsReason"
                  label={getFieldLabel(formConfig.RunawayProsReason)}
                  error={errors.RunawayProsReason}
                  value={data.RunawayProsReason.value}
                  options={getFieldOptions(data.RunawayProsReason)}
                  onChange={handleChange}
                  identical={compare("RunawayProsReason")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  labelClassName="fw-bold"
                />
                <FormTextArea
                  name="Important"
                  label={<b>{getFieldLabel(formConfig.Important)}</b>}
                  error={errors.Important}
                  value={data.Important.value}
                  onChange={handleChange}
                  identical={compare("Important")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="2"
                  divClassName="mt-2"
                />
                <FormTextArea
                  name="Triggers"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.Triggers)}</b>
                      <br />
                      {formConfig.Triggers.subLabel}
                      <br />
                      {formConfig.Triggers.subLabel2}
                      <br />
                      {formConfig.Triggers.subLabel3}
                      <br />
                      {formConfig.Triggers.subLabel4}
                    </>
                  }
                  error={errors.Triggers}
                  value={data.Triggers.value}
                  onChange={handleChange}
                  identical={compare("Triggers")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  divClassName="mt-2"
                  rows="5"
                />
                <h4 className="mt-3">PLACEMENT</h4>
                <FormTextArea
                  name="PlacementDescription"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.PlacementDescription)}</b>
                      <br />
                      <i>{formConfig.PlacementDescription.subLabel}</i>
                      <br />
                      {formConfig.PlacementDescription.subLabel2}
                      <br />
                      {formConfig.PlacementDescription.subLabel3}
                      <br />
                      {formConfig.PlacementDescription.subLabel4}
                    </>
                  }
                  error={errors.PlacementDescription}
                  value={data.PlacementDescription.value}
                  onChange={handleChange}
                  identical={compare("PlacementDescription")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  divClassName="mt-2"
                  rows="4"
                />
                <FormRadioButton
                  name="PlacementReason"
                  label={getFieldLabel(formConfig.PlacementReason)}
                  error={errors.PlacementReason}
                  value={data.PlacementReason.value}
                  options={getFieldOptions(data.PlacementReason)}
                  onChange={handleChange}
                  identical={compare("PlacementReason")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  labelClassName="fw-bold"
                />
                <h4 className="mt-3">FAMILY</h4>
                <FormTextArea
                  name="Family"
                  label={<b>{getFieldLabel(formConfig.Family)}</b>}
                  error={errors.Family}
                  value={data.Family.value}
                  onChange={handleChange}
                  identical={compare("Family")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  divClassName="mt-2"
                  rows="2"
                />
                <FormTextArea
                  name="FamilyRelationship"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.FamilyRelationship)}</b>
                      <br />
                      {formConfig.FamilyRelationship.subLabel}
                      <br />
                      {formConfig.FamilyRelationship.subLabel2}
                      <br />
                      {formConfig.FamilyRelationship.subLabel3}
                    </>
                  }
                  error={errors.FamilyRelationship}
                  value={data.FamilyRelationship.value}
                  onChange={handleChange}
                  identical={compare("FamilyRelationship")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  divClassName="mt-2"
                  rows="4"
                />
                <FormRadioButton
                  name="FamilyReason"
                  label={getFieldLabel(formConfig.FamilyReason)}
                  error={errors.FamilyReason}
                  value={data.FamilyReason.value}
                  options={getFieldOptions(data.FamilyReason)}
                  onChange={handleChange}
                  identical={compare("FamilyReason")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  labelClassName="fw-bold"
                />
                <h4 className="mt-3">FRIENDS</h4>
                <FormTextArea
                  name="Friends"
                  label={<b>{getFieldLabel(formConfig.Friends)}</b>}
                  error={errors.Friends}
                  value={data.Friends.value}
                  onChange={handleChange}
                  identical={compare("Friends")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="2"
                />
                <FormTextArea
                  name="FriendsRelationship"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.FriendsRelationship)}</b>
                      <br />
                      {formConfig.FriendsRelationship.subLabel}
                      <br />
                      {formConfig.FriendsRelationship.subLabel2}
                      <br />
                      {formConfig.FriendsRelationship.subLabel3}
                    </>
                  }
                  error={errors.FriendsRelationship}
                  value={data.FriendsRelationship.value}
                  onChange={handleChange}
                  identical={compare("FriendsRelationship")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="4"
                />
                <FormRadioButton
                  name="FriendsReason"
                  label={getFieldLabel(formConfig.FriendsReason)}
                  error={errors.FriendsReason}
                  value={data.FriendsReason.value}
                  options={getFieldOptions(data.FriendsReason)}
                  onChange={handleChange}
                  identical={compare("FriendsReason")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  labelClassName="fw-bold"
                />
                <h4 className="mt-3">OTHER CONNECTIONS</h4>
                <FormTextArea
                  name="Connections"
                  label={<b>{getFieldLabel(formConfig.Connections)}</b>}
                  error={errors.Connections}
                  value={data.Connections.value}
                  onChange={handleChange}
                  identical={compare("Connections")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="2"
                />
                <FormTextArea
                  name="ConnectionsRelationship"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.ConnectionsRelationship)}</b>
                      <br />
                      {formConfig.ConnectionsRelationship.subLabel}
                      <br />
                      {formConfig.ConnectionsRelationship.subLabel2}
                      <br />
                      {formConfig.ConnectionsRelationship.subLabel3}
                    </>
                  }
                  error={errors.ConnectionsRelationship}
                  value={data.ConnectionsRelationship.value}
                  onChange={handleChange}
                  identical={compare("ConnectionsRelationship")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="4"
                />
                <FormRadioButton
                  name="ConnectionsReason"
                  label={getFieldLabel(formConfig.ConnectionsReason)}
                  error={errors.ConnectionsReason}
                  value={data.ConnectionsReason.value}
                  options={getFieldOptions(data.ConnectionsReason)}
                  onChange={handleChange}
                  identical={compare("ConnectionsReason")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  labelClassName="fw-bold"
                />
                <h4 className="mt-3">SCHOOL</h4>
                <FormTextArea
                  name="SchoolDescription"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.SchoolDescription)}</b>
                      <br />
                      {formConfig.SchoolDescription.subLabel}
                      <br />
                      {formConfig.SchoolDescription.subLabel2}
                      <br />
                      {formConfig.SchoolDescription.subLabel3}
                      <br />
                      {formConfig.SchoolDescription.subLabel4}
                      <br />
                      {formConfig.SchoolDescription.subLabel5}
                    </>
                  }
                  error={errors.SchoolDescription}
                  value={data.SchoolDescription.value}
                  onChange={handleChange}
                  identical={compare("SchoolDescription")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="5"
                />
                <FormTextArea
                  name="SchoolPros"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.SchoolPros)}</b>
                      <br />
                      {formConfig.SchoolPros.subLabel}
                    </>
                  }
                  error={errors.SchoolPros}
                  value={data.SchoolPros.value}
                  onChange={handleChange}
                  identical={compare("SchoolPros")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="3"
                />
                <FormTextArea
                  name="SchoolCons"
                  label={
                    <>
                      <b>{getFieldLabel(formConfig.SchoolCons)}</b>
                      <br />
                      {formConfig.SchoolCons.subLabel}
                    </>
                  }
                  error={errors.SchoolCons}
                  value={data.SchoolCons.value}
                  onChange={handleChange}
                  identical={compare("SchoolCons")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="3"
                />
                <FormRadioButton
                  name="SchoolReason"
                  label={getFieldLabel(formConfig.SchoolReason)}
                  error={errors.SchoolReason}
                  value={data.SchoolReason.value}
                  options={getFieldOptions(data.SchoolReason)}
                  onChange={handleChange}
                  identical={compare("SchoolReason")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  labelClassName="fw-bold"
                />
                <h4 className="mt-3">ACTION PLAN AND INTERVENTIONS</h4>
                <b>{getFieldLabel(formConfig.RatingLabels)}</b>
                <br />
                <div className="container border my-3">
                  <div className="row border-bottom fw-bold">
                    <div className="col border-end py-2 d-flex align-items-center">
                      {formConfig.RatingLabels.col1}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {formConfig.RatingLabels.col2}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {formConfig.RatingLabels.col3}
                    </div>
                    <div className="col-3 py-2">
                      {formConfig.RatingLabels.col4}
                      <br />
                      <i className="fw-normal">
                        {formConfig.RatingLabels.subLabel}
                      </i>
                    </div>
                  </div>
                  <div className="row border-bottom">
                    <div className="col border-end py-2 d-flex align-items-center">
                      {getFieldLabel(formConfig.RunawayProsReasonRating)}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.RunawayProsReason.value === "Yes" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.RunawayProsReason.value === "No" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-3 py-2 d-flex align-items-center">
                      {data.RunawayProsReason.value === "Yes" ? (
                        <FormSelect
                          name="RunawayProsReasonRating"
                          error={errors.RunawayProsReasonRating}
                          value={data.RunawayProsReasonRating.value}
                          options={ratingOptions}
                          onChange={handleChange}
                          identical={compare("RunawayProsReasonRating")}
                          commentsHandler={handleComments}
                          disabled={formDisabled}
                          marginBottomOverride="mb-0"
                          divClassName="flex-fill"
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="row border-bottom">
                    <div className="col border-end py-2 d-flex align-items-center">
                      {getFieldLabel(formConfig.PlacementReasonRating)}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.PlacementReason.value === "Yes" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.PlacementReason.value === "No" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-3 py-2 d-flex align-items-center">
                      {data.PlacementReason.value === "Yes" ? (
                        <FormSelect
                          name="PlacementReasonRating"
                          error={errors.PlacementReasonRating}
                          value={data.PlacementReasonRating.value}
                          options={ratingOptions}
                          onChange={handleChange}
                          identical={compare("PlacementReasonRating")}
                          commentsHandler={handleComments}
                          disabled={formDisabled}
                          marginBottomOverride="mb-0"
                          divClassName="flex-fill"
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="row border-bottom">
                    <div className="col border-end py-2 d-flex align-items-center">
                      {getFieldLabel(formConfig.FamilyReasonRating)}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.FamilyReason.value === "Yes" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.FamilyReason.value === "No" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-3 py-2 d-flex align-items-center">
                      {data.FamilyReason.value === "Yes" ? (
                        <FormSelect
                          name="FamilyReasonRating"
                          error={errors.FamilyReasonRating}
                          value={data.FamilyReasonRating.value}
                          options={ratingOptions}
                          onChange={handleChange}
                          identical={compare("FamilyReasonRating")}
                          commentsHandler={handleComments}
                          disabled={formDisabled}
                          marginBottomOverride="mb-0"
                          divClassName="flex-fill"
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="row border-bottom">
                    <div className="col border-end py-2 d-flex align-items-center">
                      {getFieldLabel(formConfig.FriendsReasonRating)}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.FriendsReason.value === "Yes" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.FriendsReason.value === "No" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-3 py-2 d-flex align-items-center">
                      {data.FriendsReason.value === "Yes" ? (
                        <FormSelect
                          name="FriendsReasonRating"
                          error={errors.FriendsReasonRating}
                          value={data.FriendsReasonRating.value}
                          options={ratingOptions}
                          onChange={handleChange}
                          identical={compare("FriendsReasonRating")}
                          commentsHandler={handleComments}
                          disabled={formDisabled}
                          marginBottomOverride="mb-0"
                          divClassName="flex-fill"
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="row border-bottom">
                    <div className="col border-end py-2 d-flex align-items-center">
                      {getFieldLabel(formConfig.ConnectionsReasonRating)}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.ConnectionsReason.value === "Yes" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.ConnectionsReason.value === "No" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-3 py-2 d-flex align-items-center">
                      {data.ConnectionsReason.value === "Yes" ? (
                        <FormSelect
                          name="ConnectionsReasonRating"
                          error={errors.ConnectionsReasonRating}
                          value={data.ConnectionsReasonRating.value}
                          options={ratingOptions}
                          onChange={handleChange}
                          identical={compare("ConnectionsReasonRating")}
                          commentsHandler={handleComments}
                          disabled={formDisabled}
                          marginBottomOverride="mb-0"
                          divClassName="flex-fill"
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col border-end py-2 d-flex align-items-center">
                      {getFieldLabel(formConfig.SchoolReasonRating)}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.SchoolReason.value === "Yes" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-2 border-end gx-0 py-2 d-flex align-items-center justify-content-center">
                      {data.SchoolReason.value === "No" ? (
                        <GiCheckMark size="1.25em" />
                      ) : null}
                    </div>
                    <div className="col-3 py-2 d-flex align-items-center">
                      {data.SchoolReason.value === "Yes" ? (
                        <FormSelect
                          name="SchoolReasonRating"
                          error={errors.SchoolReasonRating}
                          value={data.SchoolReasonRating.value}
                          options={ratingOptions}
                          onChange={handleChange}
                          identical={compare("SchoolReasonRating")}
                          commentsHandler={handleComments}
                          disabled={formDisabled}
                          marginBottomOverride="mb-0"
                          divClassName="flex-fill"
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
                <FormTextArea
                  name="Requests"
                  label={<b>{getFieldLabel(formConfig.Requests)}</b>}
                  error={errors.Requests}
                  value={data.Requests.value}
                  onChange={handleChange}
                  identical={compare("Requests")}
                  commentsHandler={handleComments}
                  disabled={formDisabled}
                  rows="4"
                />
              </ExpandDiv>
              <ExpandDiv
                id="interventionGuide"
                className="mt-2"
                title="Intervention Guide"
              >
                <h4 className="p-2 bg-safy-secondary text-white">
                  Primary Run TO Reason
                </h4>
                <div className="container my-2">
                  <div className="d-flex align-items-center">
                    <b>What is the youth primarily running TO?</b>
                    <FormCheckbox
                      name="RunToNA"
                      label="Not running to anything"
                      checked={getFieldValue(data.RunToNA) === "true"}
                      onChange={handleChange}
                      commentsHandler={handleComments}
                      disabled={formDisabled}
                      divClassName="ms-3"
                    />
                  </div>
                </div>
                {data.RunToNA.value !== "true" ? (
                  <>
                    <div className="container mt-2 ms-2">
                      <div className="row">
                        <div className="col">
                          <FormCheckbox
                            name="RunToBfGf"
                            label="Boyfriend/Girlfriend"
                            checked={getFieldValue(data.RunToBfGf) === "true"}
                            onChange={handleChange}
                            commentsHandler={handleComments}
                            disabled={formDisabled}
                            labelClassName="fw-bold"
                          />
                          <ul style={{ listStyleType: "none" }}>
                            <li>- For Love</li>
                            <li>- For Belonging</li>
                            <li>- For Fun</li>
                            <li>- For Access to Car/Money</li>
                          </ul>
                        </div>
                        <div className="col">
                          <FormCheckbox
                            name="RunToSchool"
                            label="School"
                            checked={getFieldValue(data.RunToSchool) === "true"}
                            onChange={handleChange}
                            commentsHandler={handleComments}
                            disabled={formDisabled}
                            labelClassName="fw-bold"
                          />
                          <ul style={{ listStyleType: "none" }}>
                            <li>- Previous Teachers</li>
                            <li>- Previous Peers</li>
                            <li>- Academic Stability</li>
                            <li>- Extracurriculars</li>
                            <li>- Other</li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <FormCheckbox
                            name="RunToFamily"
                            label="Family"
                            checked={getFieldValue(data.RunToFamily) === "true"}
                            onChange={handleChange}
                            commentsHandler={handleComments}
                            disabled={formDisabled}
                            labelClassName="fw-bold"
                          />
                          <ul style={{ listStyleType: "none" }}>
                            <li>- To Be with Family</li>
                            <li>- For Belonging</li>
                          </ul>
                        </div>
                        <div className="col">
                          <FormCheckbox
                            name="RunToCommunity"
                            label="Community Supports"
                            checked={
                              getFieldValue(data.RunToCommunity) === "true"
                            }
                            onChange={handleChange}
                            commentsHandler={handleComments}
                            disabled={formDisabled}
                            labelClassName="fw-bold"
                          />
                          <ul style={{ listStyleType: "none" }}>
                            <li>- For Relationships</li>
                            <li>- For Transportation</li>
                            <li>- Other</li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <FormCheckbox
                            name="RunToActivities"
                            label="Preferred Activities"
                            checked={
                              getFieldValue(data.RunToActivities) === "true"
                            }
                            onChange={handleChange}
                            commentsHandler={handleComments}
                            disabled={formDisabled}
                            labelClassName="fw-bold"
                          />
                          <ul style={{ listStyleType: "none" }}>
                            <li>- For Normalcy</li>
                            <li>- For Drugs, Sex, etc.</li>
                            <li>- For Stimulation/Choices</li>
                            <li>
                              - For Involvement in Extracurricular Activities
                            </li>
                            <li>- For Independence</li>
                          </ul>
                        </div>
                        <div className="col">
                          <FormCheckbox
                            name="RunToExcitement"
                            label="Excitement"
                            checked={
                              getFieldValue(data.RunToExcitement) === "true"
                            }
                            onChange={handleChange}
                            commentsHandler={handleComments}
                            disabled={formDisabled}
                            labelClassName="fw-bold"
                          />
                          <ul style={{ listStyleType: "none" }}>
                            <li>- For an Adrenaline Rush</li>
                            <li>- For Fun</li>
                            <li>- For Absence of Rules/Freedom</li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <FormCheckbox
                            name="RunToFriends"
                            label="Friends"
                            checked={
                              getFieldValue(data.RunToFriends) === "true"
                            }
                            onChange={handleChange}
                            commentsHandler={handleComments}
                            disabled={formDisabled}
                            labelClassName="fw-bold"
                          />
                          <ul style={{ listStyleType: "none" }}>
                            <li>- For Belonging</li>
                            <li>- For Fun</li>
                            <li>- Other</li>
                          </ul>
                        </div>
                        <div className="col"></div>
                      </div>
                    </div>
                    <h4 className="p-2 bg-safy-secondary text-white">
                      Suggested Interventions
                    </h4>
                    <div className="container mt-2 mb-4">
                      {selectedReasons.map((r) => interventions[r])}
                    </div>
                    <h4 className="p-2 bg-safy-secondary text-white">
                      Other Interventions
                    </h4>
                    <div className="container my-2">
                      {otherInterventions.map((r) => interventions[r])}
                    </div>
                  </>
                ) : null}
              </ExpandDiv>
            </>
          )}
          <div>
            <div
              className="btn btn-primary m-2 d-print-none"
              onClick={() => {
                handleSubmit(null, null, null, null);
              }}
            >
              Save
            </div>
            <Signature
              canvasWidth="450"
              canvasHeight="200"
              modalTitle="Report Signatures"
              careTeams={careTeams}
              signatures={signatures}
              onSign={saveSignature}
              clientData={clientData.client}
              showModal={showSignatureModal}
              onHide={() => {
                setShowSignatureModal(false);
              }}
              finalSignType={helperConfiguration.finalSignType}
              initialSignatureType={helperConfiguration.signatureType}
            />
            <Comment
              showModal={showComment}
              commentToEdit={commentToEdit}
              onHide={() => {
                setShowComment(false);
                setCommentToEdit(undefined);
              }}
              onSave={onCommentSave}
              fields={commentFields()}
            />
            {showShare ? (
              <ShareModal
                showShare={showShare}
                onHide={() => setShowShare(false)}
                onSend={handleShareSend}
                submissionId={submissionid}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default SAFYFAIR;
